import Vue from 'vue'
import App from './App.vue'
import router from './router'


/* Inizio ElementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })
/* Fine ElementUI */

/* LOG */
if(process.env.NODE_ENV != 'development') {
  console.log = function(){}
  console.error = function(){}
}
/* FINE LOG */

/* Inizio TerAs */
var vueData = {}
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'en')
import teras from './teras'
Vue.prototype.$teras = teras
vueData.teras = teras
import axios from './teras/tAxios'
Vue.prototype.$axios = axios
vueData.axios = axios
import aes from './teras/aes'
Vue.prototype.$aes = aes
vueData.aes = aes
import './css/big.css'
/* Fine TerAs */
        

/* Inizio Storage */
import storage from './teras/tStorage' 
Vue.prototype.$storage = storage
vueData.storage = storage
/* Fine Storage */
        
Vue.config.productionTip = false

/* Inizio TerAs-event */
teras.event.on('checkAuth', async (from,to) =>{
  console.log("CHECK AUTH")
  if(storage.exist('utente')){
    console.log("YES, PRESENTE UTENTE IN LOCAL STORAGE....LO RICARICO DA LI..."+to.path)
    teras.utente = storage.load('utente')
    teras.check.admin = storage.load('admin')
    console.log(teras.utente.id)
    teras.event.emit('login',to.path)
  }else{
    teras.check.auth = false
    teras.event.emit('errore',-1,'È necessario effettuare l\'accesso prima di poter accedere alla pagina')
    if(from.path!='/login')
      router.replace('/login')
  }
})
teras.event.on('appReady', function() {
  console.log("appReady appReady appReady appReady appReady appReady appReady")
  router.push(teras.app.routeInitial)
})
teras.event.on('appExit', function() {
})
/* Fine TerAs-event */
        
window.checkFirst =function(){
  return new Promise(async (resolve, reject) => {
    //axios.query('fetchAll',`SELECT * FROM tipocamera ORDER BY peso,nome`,{},teras,'_tipocamera')
    await evento.profile.load(25001)
    
    teras.check.first = true
    resolve(true)
  })
}

window.autoLogin =  function(params,name){
  return new Promise(async (resolve, reject) => {
    console.log("PARAMS ")
    console.log(params)

    teras.utente = {}
    storage.remove('utente')
    contatto.profile.row = {}
    teras.check.auth = false
    teras.check.admin = false
    storage.remove('admin')

    if(name=='fromadmin'){
      teras.check.admin = true
      storage.save("admin",teras.check.admin)
    }
    
    //let id = aes.decode(params.contatto)
    let id = await axios.query('fetchOne','SELECT id FROM contatto WHERE id=CAST(AES_DECRYPT(UNHEX(→encrypted), password) as CHAR)',{encrypted: params.contatto})
    console.log(id)
    id = id.result

    storage.save("utente",{id:id})
    teras.utente.id = id
    let gotopage = '/home'

    if(name=='emailprimoautore'){
      let absid = await axios.query('fetchOne',`SELECT id FROM abstract WHERE id=CAST(AES_DECRYPT(UNHEX(→encrypted), 'esphm2025') as CHAR)`,{encrypted: params.abstract})
      absid = absid.result
      console.log("MI COLLEGO AD ABS "+ absid)
      await abstract.profile.load(absid)

      gotopage ='/abstract-emailprimoautore'
    }

    teras.event.emit('login',gotopage)
    resolve(true)
  })
}

/* Inizio TerAs-event-login */
teras.event.on('routerNoauth', function() {
})
teras.event.on('login', async (to) => {
  console.log("TRY LOGIN TO "+to)

  contatto.event.on('init', async () =>{
    teras.app.ready = true
    console.log("APPREADY FROM LOGIN "+contatto.profile.row.cognome)
    //if(to.path!='home' && teras.app.routeInitial!=to.path)
    router.replace(to)
 })

  await contatto.profile.load(teras.utente.id)
  storage.save("utente",contatto.profile.row)
  teras.check.auth = true
})

teras.event.on('logout', function() {
  teras.utente = {}
  storage.remove('utente')
  storage.remove('admin')
  contatto.profile.row = {}
  teras.check.auth = false
  router.replace('/login')
})
/* Fine TerAs-event-login */



import nazioni from './teras/nazioni'
Vue.prototype.$nazioni = nazioni
vueData.nazioni = nazioni
        
import evento from './teras/evento'
Vue.prototype.$evento = evento
vueData.evento = evento  

import contatto from './teras/contatto'
Vue.prototype.$contatto = contatto
vueData.contatto = contatto      
        
import abstract from './teras/abstract'
Vue.prototype.$abstract = abstract
vueData.abstract = abstract   


new Vue({

/* Inizio vue-class */
data:vueData,
/* Fine vue-class */
      
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
